import React, { useState, useEffect, Fragment } from 'react';
import { mergeStyleSets, keyframes } from '@fluentui/react';
import { CheckmarkCircleFilled } from '@fluentui/react-icons';

const fadeIn = keyframes({
    from: { opacity: 0 },
    to: { opacity: 1 },
});

function Correct(props) {

    return (
        <div className={styles.bgSuccess}>
            <div className={styles.content}>
                <CheckmarkCircleFilled style={{ fontSize: 96, color: 'var(--green)' }} />
                <h4 className="head-m mt20" style={{ color:'var(--green)' }}>Correct</h4>
            </div>
        </div>
    );
}
const styles = mergeStyleSets({
    bgSuccess: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        animationName: fadeIn,
        animationDuration: '0.3s',
        animationTimingFunction: 'ease',
        animationFillMode: 'forwards',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
});
export default Correct;